import { useUserContext } from "@/Context/UserContext";
import Link from "next/link";
import { useEffect, useState } from "react";
import LogoutModal from "./LogoutModal";
import { LoginIcon } from "./Icons";

export default function HeaderUserSection() {
  const [showLogoutButton, setShowLogoutButton] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const { user } = useUserContext();
  const userName = user?.name || "";


  useEffect(() => {
    if (showLogoutButton) {
      setIsVisible(true);
    }
  }, [showLogoutButton]);

  return userName ? <div className="">
    <div className="relative">
      <button
        className="md:w-[132px] flex flex-row"
        onClick={() => {
          if (isVisible) {
            setIsVisible(false);
          } else {
            setShowLogoutButton(true);
          }
        }}>
        <div className="w-10 h-10 rounded-full bg-blue-base flex items-center justify-center">
          <div className="text-white text-base font-medium">
            {userName.charAt(0).toUpperCase()}
          </div>
        </div>
        <div className="hidden md:block mr-2">
          <div className="text-gray-base text-sm text-right">
            {"مرحباً بك"}
          </div>
          <div className="text-black-base text-base text-right">
            {userName}
          </div>
        </div>
      </button>
      {showLogoutButton ? <div
        className="absolute bg-white-base rounded-lg shadow border border-gray-01 left-0 md:left-auto bottom-[calc(-100%-8px)] transition-all duration-500 z-50"
        style={{ opacity: isVisible ? 1 : 0, transform: `translateY(${isVisible ? "0px" : "-20px"})` }}
        onTransitionEnd={() => {
          if (!isVisible) {
            setShowLogoutButton(false);
          }
        }}
      >
        <button className="text-center text-black-base py-2.5 px-4 text-nowrap" onClick={() => {
          setShowLogoutModal(true);
          setIsVisible(false);
        }}>
          {"تسجيل خروج"}
        </button>
      </div> : null}
      {showLogoutModal ? <LogoutModal onClose={() => setShowLogoutModal(false)} /> : null}
    </div>
  </div> : <div className="md:w-[132px]">
    <Link
      href={"/login"}
      className=" focus:ring-4 w-10 md:w-full h-10 bg-blue-base hover:bg-blue-700 rounded-full text-center text-white-base flex items-center justify-center"
    >
      <div className="hidden md:block">
        {"تسجيل الدخول"}
      </div>
      <div className="md:hidden">
        <LoginIcon />
      </div>
    </Link>
  </div>
}
